<template>
    <v-dialog v-model="dialog" flat max-width="460" class="lucky-card-dialog">
        <v-row no-gutters>
            <v-spacer />
            <v-col cols="auto">
                <v-btn small icon class="transparent" @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-col>
        </v-row>
            <v-img src="/images/event/clover/lucky-card-dialog--duplicate.jpg" class="lucky-card-dialog__image">
            <v-responsive :aspect-ratio="460 / 610">
                <!-- 중복참여시 노출 X -->
                <div>
                    <div class="dialog-spacer" />
                    <router-link to="/mypage/event" target="_blank" class="dialog-button">
                        <v-img src="/images/event/clover/dialog-button.svg" alt="이벤트 참여내역" />
                    </router-link>
                    <v-container>
                        <p class="page-text page-text--small text-center mt-14px">
                            나누리 캐시는 자동지급되며 <br />
                            마이페이지 - 내 캐시내역에서 받기 후 사용하실 수 있습니다.
                        </p>
                    </v-container>
                </div>
            </v-responsive>
        </v-img>
    </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        open() {
            this.dialog = true
        },
        close() {
            this.dialog = false
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .v-dialog {
        box-shadow: none;
    }
}
.dialog-spacer {
    aspect-ratio: 460 / 450;
}
.dialog-button {
    display: block;
    max-width: calc(160 / 460 * 100%);
    margin: 0 auto;
}
.lucky-card-dialog {
    &__image {
        border-radius: 20px;
    }
}
</style>